<template>
  <v-card
    class="rounded-0 pa-7"
    elevation="0"
  >
    <v-card-title class="titreBoite"> {{$tc('accueil.BoiteEpreuvesUniquesMEQ.titre')}} </v-card-title>

    <v-expansion-panels
      multiple
      class="rounded py-2 pb-0 mt-5"
      style="min-height: 52px; !important"
    >
      <div v-html="appStore.texteDynamique.BlocTexte4">
      </div>
      <PanneauExtension
        class="my-1"
        :titre="this.appStore.texteDynamique.BlocTexte4A"
      >
        <div
          v-on:click="gererCliqueLien"
          v-html="appStore.texteDynamique.BlocTexte4B"
        >
        </div>
      </PanneauExtension>
      <PanneauExtension
        class="mb-0"
        :titre="this.appStore.texteDynamique.BlocTexte4C"
      >
        <div v-html="appStore.texteDynamique.BlocTexte4D">
        </div>
      </PanneauExtension>
    </v-expansion-panels>

  </v-card>

</template>

<script>
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import PanneauExtension from '../custom/PanneauExtension.vue';

export default {
  name: 'BoiteEpreuvesUniquesMEQ',
  components: {
    PanneauExtension,
  },
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();

    return { appStore, inscriptionStore };
  },
  methods: {
    gererCliqueLien(e) {
      const clickedElId = e.target.id;
      if (clickedElId === 'anchor') {
        this.inscriptionStore.definirPanneauCSSParticipante(0);
      }
    },
  },
  computed: {
  },
};
</script>
